import { FC } from 'react';

import { AuthProvider } from './auth.context';
import LoadingProvider from './loading';
import { AppLocaleProvider } from './locale';
import { AppSidebarProvider } from './sidebar';
import { AppThemeProvider } from './theme';

export const AppProvider: FC = ({ children }) => (
  <AuthProvider>
    <LoadingProvider>
      <AppLocaleProvider>
        <AppThemeProvider>
          <AppSidebarProvider>{children}</AppSidebarProvider>
        </AppThemeProvider>
      </AppLocaleProvider>
    </LoadingProvider>
  </AuthProvider>
);
